// extracted by mini-css-extract-plugin
export default {"wrapper":"t9ZvF"};